import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=fc20a4a8&scoped=true&"
import script from "./Product.js?vue&type=script&lang=js&"
export * from "./Product.js?vue&type=script&lang=js&"
import style0 from "./Product.css?vue&type=style&index=0&id=fc20a4a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc20a4a8",
  null
  
)

export default component.exports